// extracted by mini-css-extract-plugin
export default {"skeleton-base":"skeleton-base_skeleton-base__VN9pY","shine":"skeleton-base_shine__Fkb12"};